import { render, staticRenderFns } from "./tabs-pane.vue?vue&type=template&id=7f0af6a7&scoped=true&"
import script from "./tabs-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-pane.vue?vue&type=style&index=0&id=7f0af6a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0af6a7",
  null
  
)

component.options.__file = "tabs-pane.vue"
export default component.exports